var _circle, _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeDp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8344 18.6265H12.999C12.723 18.6265 12.499 18.4025 12.499 18.1265C12.499 17.8505 12.723 17.6265 12.999 17.6265H17.8344C18.1104 17.6265 18.3344 17.8505 18.3344 18.1265C18.3344 18.4025 18.1104 18.6265 17.8344 18.6265Z",
    fill: "#3E7EEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6632_134987",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 12,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33398 6H16.7877V18.6264H5.33398V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6632_134987)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7408 7.34443L6.46417 15.1944C6.35017 15.3371 6.30817 15.5211 6.35017 15.6978L6.80417 17.6211L8.83017 17.5958C9.02283 17.5938 9.20083 17.5078 9.31883 17.3611C11.4635 14.6778 15.5522 9.56176 15.6682 9.41176C15.7775 9.23443 15.8202 8.98376 15.7628 8.74243C15.7042 8.4951 15.5502 8.2851 15.3282 8.1511C15.2808 8.11843 14.1575 7.24643 14.1228 7.2191C13.7002 6.88043 13.0835 6.9391 12.7408 7.34443ZM6.4095 18.6264C6.17817 18.6264 5.97683 18.4678 5.92283 18.2418L5.37683 15.9278C5.26417 15.4484 5.37617 14.9538 5.6835 14.5698L11.9635 6.7151C11.9662 6.71243 11.9682 6.7091 11.9708 6.70643C12.6595 5.8831 13.9048 5.76176 14.7448 6.43576C14.7782 6.46176 15.8935 7.32843 15.8935 7.32843C16.2988 7.56976 16.6155 8.0011 16.7355 8.51176C16.8548 9.0171 16.7682 9.53843 16.4902 9.97909C16.4695 10.0118 16.4515 10.0398 10.0995 17.9864C9.7935 18.3678 9.33483 18.5898 8.84217 18.5958L6.41617 18.6264H6.4095Z",
    fill: "#3E7EEE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8163 11.7898C14.7096 11.7898 14.6029 11.7558 14.5116 11.6865L10.8769 8.8945C10.6583 8.7265 10.6169 8.41316 10.7849 8.19316C10.9536 7.9745 11.2669 7.93383 11.4863 8.10183L15.1216 10.8932C15.3403 11.0612 15.3816 11.3752 15.2129 11.5945C15.1149 11.7225 14.9663 11.7898 14.8163 11.7898Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeDp);
export default __webpack_public_path__ + "static/media/changeDp.a1d5153ef942e38f702d7a89e1381e7a.svg";
export { ForwardRef as ReactComponent };